import React from "react";
import { Tag } from "antd";
import "./style.scss";
import { TagCloseIcon } from "../../icons";


type TagCompProps = {
  color?: string;
  children: React.ReactNode;
  key?: React.Key;
  height?: number;
  onClose?: () => void;
  className?: string;
  icon?: React.ReactNode;
};

const TagComp: React.FC<TagCompProps> = ({
  color,
  children,
  key,
  height = 24,
  onClose,
  className,
  icon,
}) => {
  return (
    <Tag
      key={key}
      onClose={onClose}
      closable={!!onClose}
      closeIcon={
        onClose && (
          <span>
            <TagCloseIcon />
          </span>
        )
      }
      style={{
        height: height,
      }}
      color={color}
      className={`tag-comp ${className ?? ""}`}
    >
      {icon && <span className="tag-icon flex items-center">{icon}</span>}
      <span>{children}</span>
    </Tag>
  );
};

export default TagComp;
